import React, { Fragment } from "react";
import { Routes, Route } from "react-router-dom";
import AnalyticsSidebar from "./AnalyticsSidebar";
import AnalyticsOverview from "./AnalyticsOverview";
import AnalyticsAnalytics from "./AnalyticsAnalytics";
import AnalyticsReports from "./AnalyticsReports";
import LandingPageAnalytics from "./LandingPageAnalytics";
import Bookings from "./Bookings";
import "./AnalyticsPage.scss";

const AnalyticsPage = () => {
  return (
    <Fragment>
      <section className="analytics-section">
        <div className="container-fluid">
          <div className="row analytics-row">
            <AnalyticsSidebar />
            <div className="col-lg-10 col-md-8 analytics-content-wrapper">
              <div className="analytics-content">
                <Routes>
                  <Route index element={<AnalyticsOverview />} />
                  <Route path="analytics" element={<AnalyticsAnalytics />} />
                  <Route path="reports" element={<AnalyticsReports />} />
                  <Route path="landing-page" element={<LandingPageAnalytics />} />
                  <Route path="bookings" element={<Bookings />} />
                </Routes>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default AnalyticsPage;

